import bcrypt from "bcryptjs"

import {
  LOGIN_URL,
  ME_URL,
  REGISTER_URL,
  VALIDATE_TOKEN_URL,
  REQUEST_PASSWORD_URL,
  RESET_PASSWORD_URL,
  SIMULATE_URL
} from "../_redux/authCrud";

const API_URL = "https://graphql.brandsolo.com/v1/graphql";

export default function mockAuth(mock) {
  mock.onPost(LOGIN_URL).reply(async ({ data }) => {
    const { email, password } = JSON.parse(data);

    if (email && password) {
      const result = await fetch(
        API_URL, {
        method: "POST",
        body: JSON.stringify({
          query: `
              query brandSoloQuery($email: String!) {
                users(where: {email: {_eq: $email}}) {
                  email
                  id
                  name
                  accessToken: token
                  user_role
                  client_id
                  client {
                    id
                    currency
                    demo
                  }
                }
              }
            `,
          variables: {
            email: email,
          }
        })
      }
      );

      const { errors, data } = await result.json();

      if (errors) {
        console.error(errors);
        return [400];
      }

      if (data) {
        const result = await bcrypt.compare(password, data.users[0].accessToken);

        if (result) {
          return [200, { ...data.users[0], password: undefined }];
        }
        return [400];
      }
    }
  });

  mock.onPost(REGISTER_URL).reply(({ data }) => {
    return [400];
  });


  mock.onPost(VALIDATE_TOKEN_URL).reply(async ({ data }) => {

    const { token } = JSON.parse(data);

    const user = await fetch(
      API_URL, {
      method: "POST",
      body: JSON.stringify({
        query: `
            query brandSoloQuery($token: String!) {
              users(where: {refresh_token: {_eq: $token}}) {
                email
                id
                refresh_token
              }
            }
          `,
        variables: {
          token: token
        }
      })
    }
    );

    const response = await user.json();

    if (response) {
      return [200, { password: undefined }];
    }

    return [400];
  });

  mock.onPost(REQUEST_PASSWORD_URL).reply(async ({ data }) => {

    const { email } = JSON.parse(data);

    const url = `https://api.brandsolo.com/api/mail/reset_password`
    const result = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ email: email }),
      headers: {
        "x-api-key": "818ce9a4-4d12-43fb-aba6-faa90faf9b18",
        'Content-Type': 'application/json',
      }
    });

    const response = await result.json();

    if (response.response.accepted.length > 0) {
      return [200, { password: undefined }];
    }

  });

  mock.onPost(RESET_PASSWORD_URL).reply(async ({ data }) => {
    const { password, token } = JSON.parse(data);

    const newToken = await bcrypt.hash(password, 10);

    const userMutation = await fetch(
      API_URL, {
      method: "POST",
      body: JSON.stringify({
        query: `
          mutation update_user_token(
            $token: String!,
            $password: bpchar!
            ) {
            update_users(where: {refresh_token: {_eq: $token}}, _set: {token: $password}) {
              affected_rows
            }
          }      
        `,
        variables: {
          password: newToken,
          token: token
        }
      })
    }
    );

    const userMutationResult = await userMutation.json();

    if (userMutationResult) {
      return [200, { password: undefined }];
    }

    return [400];

  });

  mock.onGet(ME_URL).reply(async ({ headers: { Authorization } }) => {

    const accessToken =
      Authorization &&
      Authorization.startsWith("Bearer ") &&
      Authorization.slice("Bearer ".length);

    if (accessToken) {
      const user = await fetch(
        API_URL, {
        method: "POST",
        body: JSON.stringify({
          query: `
              query brandSoloQuery($token: String!) {
                users(where: {email: {_eq: $token}}) {
                  id
                  name
                  email
                  refresh_token
                  client {
                    id
                  }
                  user_role
                }
              }
            `,
          variables: {
            token: accessToken
          }
        })
      }
      );

      const response = await user.json();

      if (response) {

        const user = {
          id: response.data.users[0].id,
          email: response.data.users[0].email,
          firstname: response.data.users[0].name,
          fullname: response.data.users[0].name,
          username: response.data.users[0].email,
          roles: [0],
          client: {},
          accessToken: "access-token-" + Math.random(),
          refreshToken: "access-token-" + Math.random(),
          pic: process.env.PUBLIC_URL + "/media/users/default.jpg"
        };

        return [200, { ...user, password: undefined }];
      }
    }

    return [200, { password: undefined }];
  });

  mock.onGet(SIMULATE_URL).reply(async (data) => {

    const user = fetch(
      API_URL, {
      method: "POST",
      body: JSON.stringify({
        query: `
            query brandSoloQuery($email: String!) {
              users(where: {email: {_eq: $email}}) {
                email
                id
                name
                token
                client {
                  id
                  demo
                  currency
                }
              }
            }
          `,
        variables: {
          id: data.params
        }
      })
    }
    );

    if (user) {
      return [200, { ...user, password: undefined }];
    }
  });
}
